import { sendRequest } from "../../hooks/requests/useRequest";
import TypePersonInvoiceEnum from "../../utils/enum/type_person.enum";

export async function getPatientById(patient_id) {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Patient/FindPatientId/${patient_id}`);

    if (response.code === 200)
        return response?.data;
    else {
        return response;
    }
}

export async function updateFiscalInformationPatient({
    patient_id, id_tax_regime, type_person, rfc, cp, email, business_name
}) {
    const body = {
        id_patient: patient_id,
        id_tax_regime,
        type_person: type_person === TypePersonInvoiceEnum.FISICA ? 1 : 2,
        rfc,
        cp,
        email,
        business_name
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    }

    const response = await sendRequest(
        requestOptions, "Patient/UpdateTaxInformation"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}



export async function getListConfiguration() {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Patient/ListConfiguration`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


// ? FUNCTION CREATE PATIENT
export async function createPatientDynamic({
    formValuesPatient,
    listConfiguration,
    handleRequest
}) {


    if (!formValuesPatient) return null;


    const payload = {};

    const visibleFields = (listConfiguration || [])
        .filter(x => x.visibility_work_order === true);

    visibleFields.forEach(config => {

        const fieldName = config.field;

        if (!(fieldName in formValuesPatient)) return;

        let value = formValuesPatient[fieldName];

        if (value && typeof value === "object" && "value" in value) {
            value = value.value;
        }

        switch (fieldName) {

            case "id_state":
                payload.id_state_patient = value ?? null;
                break;

            case "id_municipality":
                payload.id_municipality_patient = value ?? null;
                break;

            case "id_social_gender":
                payload.id_social_gender = value ?? null;
                break;

            case "address":
                payload.address_patient = value ?? null;
                break;

            case "cp":
                payload.cp_patient = value ?? null;
                break;

            case "colony":
                payload.colony_patient = value ?? null;
                break;

            case "phone":
                payload.phone = value ?? "";
                break;

            case "email":
                payload.email_patient = value ?? "";
                break;

            case "nss":
                payload.nss = value ?? 0;
                break;

            default:
                payload[fieldName] = value ?? null;
                break;
        }

    });

    payload.type_person = formValuesPatient.type_person ?? null;
    payload.scan_ine_check = formValuesPatient.scan_ine_check ?? false;
    payload.setFileINE = formValuesPatient.setFileINE ?? null;


    const response = await handleRequest(
        "POST",
        "Patient",
        "Paciente",
        payload
    );

    return response;
}

// ? FUNCTION UPDATE PATIENT
export async function updatePatientDynamic({
    id_patient,
    formValuesPatient,
    listConfiguration,
    handleRequest
}) {


    if (!formValuesPatient || !id_patient) return null;

    const formData = new FormData();
    formData.append("id_patient", id_patient);

    const visibleFields = (listConfiguration || [])
        .filter(x => x.visibility_work_order === true);

    visibleFields.forEach(config => {

        const fieldName = config.field;

        if (!(fieldName in formValuesPatient)) return;

        let value = formValuesPatient[fieldName];

        if (value && typeof value === "object" && "value" in value) {
            value = value.value;
        }

        switch (fieldName) {

            case "id_state":
                formData.append("id_state_patient", value ?? "");
                break;

            case "id_municipality":
                formData.append("id_municipality_patient", value ?? "");
                break;

            case "id_social_gender":
                formData.append("id_social_gender_patient", value ?? "");
                break;

            case "email":
                formData.append("email_patient", value ?? "");
                break;

            case "phone":
                formData.append("phone", value ?? "");
                break;

            case "cp":
                formData.append("cp", value ?? "");
                break;

            case "nss":
                formData.append("nss", value ?? "");
                break;

            case "matricula_buap":
                formData.append("matricula_buap", value ?? "");
                break;

            case "expedient_number":
                formData.append("expedient_number", value ?? "");
                break;

            case "address":
                formData.append("address", value ?? "");
                break;

            case "colony":
                formData.append("colony", value ?? "");
                break;

            default:
                formData.append(fieldName, value ?? "");
                break;
        }

    });

    const response = await handleRequest(
        "PUT",
        "Patient/UpdateShort",
        "Paciente",
        formData,
        true
    );

    return response;
}


// ? FUNCTIOM HISTORICA PATIENT
export async function updateHistoricalPatient({
    modifiedHistoricalFields
}) {
    const body = modifiedHistoricalFields;

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    }

    const response = await sendRequest(
        requestOptions, "Patient/CreateHistoricalData"
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


export async function getValidateCancel(_id_workOrder) {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/ValidateCancel/${_id_workOrder}`);

    if (response.code === 200)
        return response?.data;
    else {
        return response;
    }
}

// ? DETAIL PATIENT

export async function getViewHistorical(patient_id) {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Patient/ViewHistorical/${patient_id}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}







